import { InfoIcon } from "@/components/icons/info-icon";
import IconButton from "@/components/ui/buttons/IconButton";
import { FruitPicksBottomSheet } from "@/features/meal-plan/components/fruit-picks-bottom-sheet";
import { useState } from "react";

export const FruitInfoIconButton = () => {
  const [isFruitPicksOpen, setIsFruitPicksOpen] = useState(false);

  return (
    <>
      <IconButton
        className="h-11 w-11"
        onClick={(event) => {
          // Prevent triggering the parent meal card click handler.
          event.stopPropagation();
          setIsFruitPicksOpen(true);
        }}
      >
        <InfoIcon className="fill-os-brand" />
      </IconButton>

      <FruitPicksBottomSheet
        isOpen={isFruitPicksOpen}
        onDismiss={() => setIsFruitPicksOpen(false)}
      />
    </>
  );
};
